export default {
	en: {
		listtitle: 'Sysmologic sensors list',
		code: 'Code',
		city: 'Location',
		elevation: 'Elevation',
		latitude: 'Latitude',
		longtitude: 'Longtitude',
		sensor: 'Sensor'
	},
	sq: {
		listtitle: 'Lista e sensorëve sizmik',
		code: 'Kodi',
		city: 'Vendodhja',
		elevation: 'Lartësia mbi nivel deti',
		latitude: 'Latituda',
		longtitude: 'Longituda',
		sensor: 'Sensor'
	}
};
